import React from "react";
import "./completeedSlist.css";
import { IP } from "../../../../../internalServer";

const CompletedSlist = ({ preCompleteSList }) => {
  console.log("preCompleteSList", preCompleteSList);

  const myList = [preCompleteSList];
  const totalLength = myList
    .map((array) => array.length)
    .reduce((sum, length) => sum + length, 0);

  return (
    <>
      <div className=" mt-2 p-0 Slist_container_PreRead ">
        <div className=" header_colour"></div>
        <div className="px-2 mt-2 d-flex align-items-center justify-content-between header_box">
          <span>Pre-read completed by</span>
          {/* <img
            src="/images/cross.svg"
            alt=""
            style={{ cursor: "pointer" }}
            onClick={() => {
              setClick(false);
            }}
          /> */}
        </div>
        <div className="mx-2 mt-1 no_of_studentPre">
          Total {totalLength} Students
        </div>
        <div className="p-2 mt-1 mx-2  pre_completed_list">
          {preCompleteSList.map((preSList) => (
            <div className="mb-2 gap-2 d-flex align-items-center  ">
              {/* <img src={preSList.student_id.profile_picture
                ? IP +
                  preSList.student_id.profile_picture.substring(
                    preSList.student_id.profile_picture.indexOf("/")
                  )
                : "/images/status circle1.svg"} alt="" /> */}
              {
                <img
                  src={
                    preSList?.student_id
                      ? IP +
                        preSList?.student_id?.profile_picture.replace(/^\./, "")
                      : preSList?.student_id?.gender === "M"
                      ? preSList?.student_id?.avatar_profile
                        ? "/images/Boys/" +
                          preSList?.student_id?.avatar_profile +
                          ".webp"
                        : "/images/Student_boy_pic.png"
                      : preSList?.student_id?.gender === "F"
                      ? preSList?.student_id?.avatar_profile
                        ? "/images/Girls/" +
                          preSList?.student_id?.avatar_profile +
                          ".webp"
                        : "/images/Student_girl_pic.png"
                      : "/images/default image.png"
                  }
                  alt="icon"
                  style={{ width: "20px", height: "20px", borderRadius: "50%" }}
                  className=""
                  key={preSList?.student_id?.avatar_profile}
                  onError={(e) => {
                    if (preSList?.student_id?.gender === "M") {
                      e.target.src = preSList?.student_id?.avatar_profile
                        ? "/images/Boys/" +
                          preSList?.student_id?.avatar_profile +
                          ".webp"
                        : "/images/Student_boy_pic.png";
                    } else if (preSList?.student_id?.gender === "F") {
                      e.target.src = preSList?.student_id?.avatar_profile
                        ? "/images/Girls/" +
                          preSList?.student_id?.avatar_profile +
                          ".webp"
                        : "/images/Student_girl_pic.png";
                    } else {
                      e.target.src = "/images/default image.png";
                    }
                  }}
                />
              }
              <span className=" completed_s_name">
                {preSList?.student_id?.name} |{" "}
                {"Roll No: " + preSList?.student_id?.roll_number}
              </span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CompletedSlist;
